<template>
  <div>
    <va-inner-loading :loading="loader">
      <va-card class="mb-4">
        <div class="d-flex justify--space-between">
          <h1>Заявки на создание букета</h1>
        </div>
        <div v-if="florists.length" class="mt-3" style="max-width: 300px">
          <va-select
            v-model="selectedFloristId"
            :options="florists"
            text-by="name"
            value-by="id"
            placeholder="Фильтр по флористу"
            clearable
            @input="loadRequests"
          />
        </div>
      </va-card>

      <florist-requests-table
        class="mb-4"
        :requests="requests"
        :florists="florists"
        @refresh="loadRequests"
      />
    </va-inner-loading>
  </div>
</template>

<script>
import FloristRequestsTable from '../../components/florist-requests/florist-requests-table.vue';
import api from '@/api/axios';
import { mapGetters } from 'vuex';

export default {
  name: 'FloristRequests',
  components: { FloristRequestsTable },
  data() {
    return {
      requests: [],
      florists: [],
      selectedFloristId: null,
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      loader: 'isLoading',
    }),
  },
  async created() {
    await this.loadFlorists();
    await this.loadRequests();
  },
  methods: {
    async loadFlorists() {
      try {
        const response = await api.get('/admin/florists', { params: { all: 1 } });
        this.florists = response.data.data || [];
      } catch (error) {
        console.error('Ошибка загрузки флористов:', error);
        this.florists = [];
      }
    },
    async loadRequests() {
      this.loading = true;
      try {
        const params = { all: 1 };
        if (this.selectedFloristId) {
          params.florist_id = this.selectedFloristId;
        }
        const response = await api.get('/admin/florist-requests', { params });
        // Обрабатываем как пагинацию, так и простой массив
        this.requests = response.data.data || response.data || [];
      } catch (error) {
        console.error('Ошибка загрузки заявок:', error);
        this.requests = [];
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style></style>

